var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7466 5.63335C13.0466 2.55335 10.3599 1.16669 7.99994 1.16669C7.99994 1.16669 7.99994 1.16669 7.99327 1.16669C5.63994 1.16669 2.94661 2.54669 2.24661 5.62669C1.46661 9.06669 3.57328 11.98 5.47994 13.8134C6.18661 14.4934 7.09328 14.8334 7.99994 14.8334C8.90661 14.8334 9.81328 14.4934 10.5133 13.8134C12.4199 11.98 14.5266 9.07335 13.7466 5.63335ZM7.99994 8.97335C6.83994 8.97335 5.89994 8.03335 5.89994 6.87335C5.89994 5.71335 6.83994 4.77335 7.99994 4.77335C9.15994 4.77335 10.0999 5.71335 10.0999 6.87335C10.0999 8.03335 9.15994 8.97335 7.99994 8.97335Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fbbdb91668aa2ccb0de4090200c708a4.svg";
export { ForwardRef as ReactComponent };